/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Cooling_Setpoint_Above_HeatingInputs */



/**
* | output |
* | --- |
* | "The cooling setpoint must be above the heating setpoint" |
*
* @param {Air_Handler_Unit_Cooling_Setpoint_Above_HeatingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_cooling_setpoint_above_heating = /** @type {((inputs?: Air_Handler_Unit_Cooling_Setpoint_Above_HeatingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Cooling_Setpoint_Above_HeatingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The cooling setpoint must be above the heating setpoint")
	return /** @type {LocalizedString} */ ("La consigne froid doit être supérieure à la consigne chaud")
});